export const UPDATE_NEW_PACKSHOT = 'UPDATE_NEW_PACKSHOT';
export const UPDATE_NEW_SPECIFIC_PACKSHOT = 'UPDATE_NEW_SPECIFIC_PACKSHOT';
export const ASSETS_RECEIVE_ALL = 'ASSETS_RECEIVE_ALL';
export const UPDATE_SPECIFIC_ASSET = 'UPDATE_SPECIFIC_ASSET';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const UPDATE_SELECTED_IDS = 'UPDATE_SELECTED_IDS';
export const CLEAR_SELECTED_IDS = 'CLEAR_SELECTED_IDS';
export const SET_CURRENT_ASSET_TAB = 'SET_CURRENT_ASSET_TAB';
